function openCouponHistory() {
  const locale = window.Shopify.locale;
  if (locale != 'th'){
    window.location.href =
    "/" + locale + "/pages/coupon-history";
  }
  else{
    window.location.href = "/pages/coupon-history";
  }

}
function userItNow(code) {
  const locale = window.Shopify.locale;
  if (locale != 'th'){
    window.location.href =
    "/" + locale + "/pages/membership-voucher-detail" + "?id=" + encodeURIComponent(code);
  }
  else{
    window.location.href = "/pages/membership-voucher-detail" + "?id=" + encodeURIComponent(code);
  }

}

function formatDate(dateString) {
  const locale = window.Shopify.locale; // "th" hoặc "en"
  const date = new Date(dateString);

  const day = date.getDate();
  const year = date.getFullYear(); // luôn lấy Gregorian year

  // Nếu là tiếng Thái
  if (locale === "th") {
    // Lấy tháng viết tắt bằng tiếng Thái
    const month = date.toLocaleDateString("th-TH", { month: "short" });
    return `${month} ${day}, ${year}`;
  } else {
    // Mặc định English
    const month = date.toLocaleDateString("en-US", { month: "short" });
    return `${month} ${day}, ${year}`;
  }
}

function myCouponOnLoad(cus_phone, all=0) {
  if (all == 1){
    $(".load-more").css("display", "none");
  }
  var settings = {
    url: "https://api.backend.gw.t.int.suparagroup.com/gq-connect/auth/token",
    method: "POST",
    timeout: 0,
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify({
      api_key: "98931F7B-B67D-492C-96F1-A50D66C4DA1B",
      client: "magenest",
    }),
  };

  $.ajax(settings).done(function (response) {
    supara_token = response.data.token;
    var url = "https://api.backend.gw.t.int.suparagroup.com/gq-connect/magenest/customers/get/coupons?mobile="+ parseInt(cus_phone) +"&limit=9&offset=0";
    if (all == 1){
      url = "https://api.backend.gw.t.int.suparagroup.com/gq-connect/magenest/customers/get/coupons?mobile="+ parseInt(cus_phone) +"&limit=50&offset=0";
    }
    var ajax_reward = {
      url: url,
      method: "GET",
      timeout: 0,
      headers: {
        Authorization: "Bearer " + supara_token,
      },
    };
    $.ajax(ajax_reward).done(function (response) {
      const locale = window.Shopify.locale;
      if (locale != "th") {
        expire_in = 'Expire in: ';
      } else {
        expire_in = 'หมดอายุภายใน: ';
      }
      var reward_list_html = "";
      var inactive_reward_list_html = "";
      var expire_img = '<svg xmlns="http://www.w3.org/2000/svg" width="210" height="210" viewBox="0 0 210 210" style="width: 70%;height: 100%;z-index: 99;position: relative;">'+
  '<g id="Group_8593" data-name="Group 8593" transform="translate(12603 -3639)">'+
    '<g id="Ellipse_60" data-name="Ellipse 60" transform="translate(-12603 3639)" fill="#efefef" stroke="#efefef" stroke-width="1">'+
      '<circle cx="105" cy="105" r="105" stroke="none"/>'+
      '<circle cx="105" cy="105" r="104.5" fill="none"/></g>'+
    '<g id="Group_8592" data-name="Group 8592" transform="translate(-13333 2551)">'+
      '<g id="Ellipse_56" data-name="Ellipse 56" transform="translate(739 1097)" fill="none" stroke="#a7a7a7" stroke-width="6">'+
        '<circle cx="96" cy="96" r="96" stroke="none"/>'+
        '<circle cx="96" cy="96" r="93" fill="none"/></g>'+
      '<path id="Path_3356" data-name="Path 3356" d="M1.575-24.465h17.36v5.215H7.77v4.585h8.155V-9.8H7.77v4.585H18.935V0H1.575ZM29.365-12.25l-8.82-12.215H27.65l5.285,7.315,5.285-7.315h7.1L36.47-12.25,45.325,0h-7.1L32.935-7.315,27.615,0h-7.1Zm18.41-12.215h10.78a9.983,9.983,0,0,1,6.825,2.24,7.892,7.892,0,0,1,2.555,6.265A8.1,8.1,0,0,1,65.4-9.573a9.919,9.919,0,0,1-6.842,2.258H53.97V0H47.775Zm9.8,11.935A4.91,4.91,0,0,0,60.5-13.3a3.061,3.061,0,0,0,1.068-2.66,2.889,2.889,0,0,0-1.05-2.59,5.267,5.267,0,0,0-2.94-.7h-3.6v6.72Zm12.46-11.935H76.23V0H70.035Zm9.345,0H90.37a9.766,9.766,0,0,1,6.737,2.17,7.913,7.913,0,0,1,2.433,6.23,8.684,8.684,0,0,1-1.19,4.655,7.238,7.238,0,0,1-3.36,2.87L99.33,0H92.96L89.075-7.665h-3.5V0H79.38ZM89.285-12.88a4.921,4.921,0,0,0,2.87-.717,2.813,2.813,0,0,0,1.015-2.468,2.822,2.822,0,0,0-1-2.5,5.1,5.1,0,0,0-2.887-.683h-3.71v6.37Zm12.7-11.585h17.36v5.215H108.185v4.585h8.155V-9.8h-8.155v4.585H119.35V0H101.99Zm19.81,0h8.785A15.856,15.856,0,0,1,137.62-23a10.709,10.709,0,0,1,4.637,4.218,12.366,12.366,0,0,1,1.628,6.423q0,6.09-3.57,9.222T130.41,0H121.8Zm9.135,19.25a6.164,6.164,0,0,0,4.883-1.925,7.6,7.6,0,0,0,1.7-5.215,7.252,7.252,0,0,0-1.7-4.953,5.881,5.881,0,0,0-4.673-1.942h-3.15V-5.215Z" transform="translate(763 1205)" fill="#494949"/></g></g></svg>'
      
      var used_img = '<svg xmlns="http://www.w3.org/2000/svg" width="210" height="210" viewBox="0 0 210 210" style="width: 70%;height: 100%;z-index: 99;position: relative;">'+
  '<g id="Group_8591" data-name="Group 8591" transform="translate(13606 -3639)">'+
    '<g id="Ellipse_59" data-name="Ellipse 59" transform="translate(-13606 3639)" fill="#efefef" stroke="#efefef" stroke-width="1"><circle cx="105" cy="105" r="105" stroke="none"/><circle cx="105" cy="105" r="104.5" fill="none"/></g>'+
    '<g id="Group_8590" data-name="Group 8590" transform="translate(-14336 2551)">'+
      '<g id="Ellipse_56" data-name="Ellipse 56" transform="translate(739 1097)" fill="none" stroke="#a7a7a7" stroke-width="6"><circle cx="96" cy="96" r="96" stroke="none"/><circle cx="96" cy="96" r="93" fill="none"/></g>'+
      '<path id="Path_3355" data-name="Path 3355" d="M12.53.525Q7,.525,4.2-2.432a10.91,10.91,0,0,1-2.8-7.823v-14.21H7.595v14.28a4.91,4.91,0,0,0,1.313,3.71,5.014,5.014,0,0,0,3.623,1.26,4.952,4.952,0,0,0,3.6-1.26,4.948,4.948,0,0,0,1.3-3.71v-14.28h6.195v14.21a10.937,10.937,0,0,1-2.783,7.84Q18.06.525,12.53.525Zm21.7,0A24.225,24.225,0,0,1,29.645.087,13.712,13.712,0,0,1,25.9-1.12V-6.685a17.243,17.243,0,0,0,3.938,1.47,16.775,16.775,0,0,0,3.9.49,5.118,5.118,0,0,0,2.59-.525A1.661,1.661,0,0,0,37.2-6.755a1.883,1.883,0,0,0-.472-1.278,4.451,4.451,0,0,0-1.382-1q-.91-.455-2.835-1.26a13.55,13.55,0,0,1-4.935-3.185,6.284,6.284,0,0,1-1.54-4.305,6.292,6.292,0,0,1,1.173-3.745,7.629,7.629,0,0,1,3.273-2.555,12.05,12.05,0,0,1,4.83-.91,20.472,20.472,0,0,1,3.99.35,14.222,14.222,0,0,1,3.36,1.12V-18.1A13.258,13.258,0,0,0,36.47-19.7a5.619,5.619,0,0,0-2.678.542,1.7,1.7,0,0,0-1,1.557A1.882,1.882,0,0,0,33.81-15.96a27.011,27.011,0,0,0,3.745,1.715,19.762,19.762,0,0,1,3.868,1.995,6.058,6.058,0,0,1,2.012,2.275,7.518,7.518,0,0,1,.63,3.29,6.324,6.324,0,0,1-2.468,5.3Q39.13.525,34.23.525Zm12.285-24.99h17.36v5.215H52.71v4.585h8.155V-9.8H52.71v4.585H63.875V0H46.515Zm19.81,0H75.11A15.856,15.856,0,0,1,82.145-23a10.71,10.71,0,0,1,4.637,4.218,12.366,12.366,0,0,1,1.628,6.423q0,6.09-3.57,9.222T74.935,0h-8.61ZM75.46-5.215A6.164,6.164,0,0,0,80.342-7.14a7.6,7.6,0,0,0,1.7-5.215,7.252,7.252,0,0,0-1.7-4.953A5.881,5.881,0,0,0,75.67-19.25H72.52V-5.215Z" transform="translate(791 1205)" fill="#494949"/></g></g></svg>'
      
      for (i = 0; i < response.data.length; i++) {
        coupon = response.data[i]['coupon'];
        campaign = response.data[i]['campaign'];
        if (locale != "th") {
          coupon_img = campaign.image_en;
          coupon_name = campaign.name_en;
        } else {
          coupon_img = campaign.image_th;
          coupon_name = campaign.name_th;
        }
          var expiryDate = new Date(coupon.expiration_date);
          var currentDate = new Date();
          if (
            expiryDate > currentDate
          ) {
            if(!coupon.used_expire_date){
              expiry_soon = ">";
              if ((expiryDate - currentDate) / (1000 * 60 * 60 * 24) < 7) {
                if (locale != "th") {
                  expiry_soon = ' style="padding:0 3%;" >Expiring soon';
                }else{
                    expiry_soon = ' style="padding:0 3%;" >คูปองใกล้หมดอายุ';
                }

              }
                
              reward_list_html =
                reward_list_html +
                '<div class="redeem-reward-div"><a onclick="userItNow(' +
                coupon.coupon_id +
                ')"><div class="redeem-reward-img-div">' +
                '<img class="redeem-reward-img" src="' +
                coupon_img +
                '">' +
                '</div><div class="redeem-reward-label-div"><div class="redeem-reward-title">' +
                coupon_name +
                '</div><div class="highest-tier" ' +
                expiry_soon +
                '</div><div class="reward-expire">'+ expire_in +
                formatDate(coupon.expiration_date) +
                '</div></div></a></div>';
            } else{
              inactive_reward_list_html =
                inactive_reward_list_html +
                '<div class="redeem-reward-div">' +
                // <a onclick="userItNow(' +
                // coupon.coupon_id +
                // ')">
                '<div class="redeem-reward-img-div">' +
                '<img class="redeem-reward-img" src="' +
                coupon_img +
                '">' +
                '<div class="coupon-used">'+used_img+'<div class="coupone-inactive-overlay"></div></div><div class="redeem-reward-label-div"><div class="redeem-reward-title">' +
                coupon_name +
                '</div><div class="highest-tier">' +
  
                '</div><div class="reward-expire">'+ expire_in +
                formatDate(coupon.expiration_date) +
                '</div></div></div></div>';
                // '</div></div></a></div>';
            }
          } else{
            inactive_reward_list_html =
                inactive_reward_list_html +
                '<div class="redeem-reward-div">' +
                // <a  onclick="userItNow(' +
                // coupon.coupon_id +
                // ')">
                '<div class="redeem-reward-img-div">' +
                '<img class="redeem-reward-img" src="' +
                coupon_img +
                '">' +
                '<div class="coupon-used">'+expire_img+'<div class="coupone-inactive-overlay"></div></div><div class="redeem-reward-label-div"><div class="redeem-reward-title">' +
                coupon_name +
                '</div><div class="highest-tier">' +
  
                '</div><div class="reward-expire">'+ expire_in +
                formatDate(coupon.expiration_date) +
                '</div></div></div></div>';
                // '</div></div></a></div>';
          }
      }
      document.getElementById("redeem-reward-list").innerHTML =
        reward_list_html;
      document.getElementById("redeem-reward-inactive-list").innerHTML =
        inactive_reward_list_html;
    });
  });
}

function openCouponTab(n) {
  couponTab = document.getElementsByClassName("coupon-tab-title");
  if (n==1){
    document.getElementById("redeem-reward-list").style.display = "flex";
    couponTab[0].className += " coupon-tab-active";
    document.getElementById("redeem-reward-inactive-list").style.display = "none";
    couponTab[1].className = couponTab[1].className.replace(" coupon-tab-active", "");
  } else{
    document.getElementById("redeem-reward-list").style.display = "none";
    couponTab[1].className += " coupon-tab-active";
    document.getElementById("redeem-reward-inactive-list").style.display = "flex";
    couponTab[0].className = couponTab[0].className.replace(" coupon-tab-active", "");
  }
  
}

$(document).ready(function () {
  // if ($(window).width() <= 768) {
  //   $(".page-account .sidebar-main .sidebar-section").click(function () {
  //     $(this).toggleClass("open-tab");
  //     $(this).next().slideToggle("slow");
  //   });
  // }
  var modal = $(".central.rte .modal");
  var overlay = $(".central.rte .overlay");
  const closeModal = function () {
    modal.addClass("hidden");
    overlay.addClass("hidden");
  };
  overlay.click(closeModal);
  $(".sidebar-main .cancel-logout-button").click(closeModal);

  function openPopup(popuplink) {
    popuplink.nextAll(".overlay,.modal").removeClass("hidden");
  }
  $(".sidebar-main .log-out").click(function () {
    openPopup($(this));
  });
});
